import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  associatePin: '',
  associateWidgetInfo: {
    reminders: false,
    todaysSales: false,
    recentOrders: false,
    alterations: false,
    memos: false,
  },
  associateWidgetUpdateResult: '',
};

const accountAssociateWidgetInformation = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_LOADING:
    case actionTypes.ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_SUCCESS:
      return {
        ...state,
        loading: false,
        ...payload,
        associateWidgetUpdateResult: INITIAL_STATE.associateWidgetUpdateResult,
      };
    case actionTypes.ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_ERROR:
      return {
        ...INITIAL_STATE,
        error: payload,
      };
    case actionTypes.ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_SUCCESS:
      return {
        ...state,
        loading: false,
        associatePin: payload?.requestPayload?.associatePin,
        associateWidgetUpdateResult: payload?.response,
        associateWidgetInfo: payload?.requestPayload?.associateWidgetInfo,
      };
    case actionTypes.ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_ERROR:
      return {
        ...INITIAL_STATE,
        error: payload,
      };
    default:
      return state;
  }
};

export default accountAssociateWidgetInformation;
